// src/pages/SearchResults.jsx
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import ProductCard from '../components/product/ProductCard';

function SearchResults() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const query = searchParams.get('query') || '';

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!query) { setLoading(false); return; }

    setLoading(true);
    axios
      .get('https://madadline.com/api/products/search', { params: { query } })
      .then(res => setProducts(Array.isArray(res.data) ? res.data : []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [query]);

  return (
    <main className="search-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <span className="page-hero__label">{t('search.heroLabel')}</span>
          <h1 className="page-hero__title">
            {query
              ? t('search.heroTitleQuery', { q: query })
              : t('search.heroTitleDefault')}
          </h1>
          {!loading && (
            <p className="page-hero__subtitle">
              {t('search.results', {
                n: products.length,
                plural: products.length > 1 ? 's' : '',
              })}
            </p>
          )}
        </div>
      </header>

      <section className="search-content">
        {loading ? (
          <div className="search-loading"><div className="spinner" /></div>
        ) : products.length === 0 ? (
          <div className="search-empty">
            <h2>{t('search.emptyTitle', { q: query })}</h2>
            <p>{t('search.emptyText')}</p>
            <Link to="/boutique" className="btn btn-primary">
              {t('search.emptyButton')}
            </Link>
          </div>
        ) : (
          <div className="grid-products">
            {products.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </section>
    </main>
  );
}
export default SearchResults;